import { get, post } from "./api";

export const submitPracticeDetail = (data, customer_id) => {
  const url = customer_id !== null ? `/api/v2/setup/detail/${customer_id}/` : `/api/v2/setup/detail/`;

  return post(url, data);
};

export const submitPracticePerformance = (data, customer_id) => {
  const url = `/api/v2/setup/performance/${customer_id}/`;
  return post(url, data);
};

export const submitBankConnected = (data, customer_id) => {
  const url = `api/v2/setup/bankConnected/${customer_id}/`;
  return post(url, data);
};

export const updateHighlevelSaasPipelineStage = (stageName) => {
  const url = `api/v2/setup/highlevel-stage/`;
  return post(url, { stageName });
};

export const skippedSetup = () => {
  const url = `api/v2/setup/skip/`;
  return post(url, null);
};

export const completedSetup = () => {
  const url = `api/v2/setup/complete/`;
  return post(url, null);
};

export const loadSetup = ({ signal } = {}) => {
  const url = `api/v2/setup/load/`;
  return get(url, {}, false, signal ?? null, false);
};

export const completedSetupCustomer = (customer_id) => {
  const url = `api/v2/customers/${customer_id}/setup/complete/`;
  return post(url, null);
};

export const fetchSetupCalendarFreeSlots = ({ date, timezone, calendarId, bookingType }) => {
  const url = `api/v2/setup/calendar/free-slots/`;
  return get(url, {
    date,
    timezone,
    ...(bookingType ? { bookingType } : {}),
    ...(calendarId ? { calendarId } : {}),
  });
};

export const fetchSetupCalendarAvailableDates = ({ month, timezone, calendarId, bookingType }) => {
  const url = `api/v2/setup/calendar/available-dates/`;
  return get(url, {
    month,
    timezone,
    ...(bookingType ? { bookingType } : {}),
    ...(calendarId ? { calendarId } : {}),
  });
};

export const bookSetupCalendarAppointment = (data) => {
  const url = `api/v2/setup/calendar/book/`;
  return post(url, data);
};
